import React, { useId } from "react";

export function validBullseyeCompetitorId(value) {
  const id = String(value || "").trim();
  return !id || /^[0-9]{15}$/.test(id);
}

export default function BullseyeNraIdentityFields({ value, onChange, disabled = false }) {
  const hintId = useId();
  const invalid = !validBullseyeCompetitorId(value.bullseyeNraCompetitorId);
  return <>
    <label className="leaderboard-field">
      <span>NRA Member ID (optional)</span>
      <input className="match-search" type="text" value={value.nraMemberId}
        onChange={event => onChange("nraMemberId", event.target.value)} disabled={disabled} />
    </label>
    <div className="leaderboard-field">
      <span><label htmlFor={`${hintId}-input`}>NRA Competitor ID (optional)</label></span>
      <input id={`${hintId}-input`} className="match-search" type="text" inputMode="numeric"
        value={value.bullseyeNraCompetitorId} aria-invalid={invalid} aria-describedby={hintId}
        onChange={event => onChange("bullseyeNraCompetitorId", event.target.value)} disabled={disabled} />
      <small id={hintId} className={`bullseye-id-hint${invalid ? " bullseye-id-hint-error" : ""}`}>
        {invalid ? "Enter 15 digits or leave blank." : "15 digits; leave blank if not assigned."}
      </small>
    </div>
  </>;
}
